module.exports = __webpack_public_path__ + "assets/img/eyedock_logo.3418d250.svg";